export default __webpack_public_path__ + "static/media/5.cb7c3c6b.jpg";